import SizeGuide from "./SizeGuide";
customElements.define('size-guide', SizeGuide)